export const SEARCH_TEXT_INPUT = 'SEARCH_TEXT_INPUT';
export const DIRECT_TO_EVENT_DETAILS = 'DIRECT_TO_EVENT_DETAILS';
export const REDIRECT_TO_EVENT = 'REDIRECT_TO_EVENT';
export const REDIRECT_TO_PORTAL_EVENT = 'REDIRECT_TO_PORTAL_EVENT';
export const DIRECT_TO_PORTAL_EVENT_DETAILS =
  'REDIRECT_TO_PORTAL_EVENT_DETAILS';
import { RESET_EVENT } from '../../routes/EventDetails/modules/constants';
import { LOCATION_CHANGE } from '../../store/location';

export const searchBarInput = (text) => {
  return {
    type: SEARCH_TEXT_INPUT,
    text,
  };
};

export const resetEvent = () => {
  return {
    type: RESET_EVENT,
  };
};

export const redirectToEvent = (eventId) => {
  return {
    type: REDIRECT_TO_EVENT,
    eventId,
  };
};

export const redirectToPortalEvent = (eventId) => {
  return {
    type: REDIRECT_TO_PORTAL_EVENT,
    eventId,
  };
};

export const directToPortalEventDetails = (eventId) => {
  return (dispatch) => {
    dispatch(resetEvent());
    dispatch(redirectToPortalEvent(eventId));
    return {
      type: DIRECT_TO_PORTAL_EVENT_DETAILS,
    };
  };
};

export const directToEventDetails = (eventId) => {
  return (dispatch) => {
    dispatch(resetEvent());
    dispatch(redirectToEvent(eventId));
    return {
      type: DIRECT_TO_EVENT_DETAILS,
    };
  };
};

const ACTION_HANDLERS = {
  [SEARCH_TEXT_INPUT]: (state, action) => {
    const newState = {};
    Object.assign(newState, state, { text: action.text });
    return newState;
  },
  [LOCATION_CHANGE]: (state, action) => {
    const newState = {};
    Object.assign(newState, initialState);
    return newState;
  },
  [DIRECT_TO_EVENT_DETAILS]: (state) => {
    const newState = {};
    Object.assign(newState, initialState);
    return newState;
  },
  [DIRECT_TO_PORTAL_EVENT_DETAILS]: (state) => {
    const newState = {};
    Object.assign(newState, initialState);
    return newState;
  },
  [REDIRECT_TO_EVENT]: (state) => {
    const newState = {};
    Object.assign(newState, initialState);
    return newState;
  },
  [REDIRECT_TO_PORTAL_EVENT]: (state) => {
    const newState = {};
    Object.assign(newState, initialState);
    return newState;
  },
};

const initialState = {
  results: [],
  error: '',
  isLoading: false,
  text: '',
};

export default function siteSearchReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// ./src/common/modules/siteSearch.js